export class TransactionModel {
    CardNumber: string;
    ExpirationDate: string;
    EmailId: string;
    OrderId: string;
    CVV: string;
    Amount: any;
}
